import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button, CircularProgress } from "@material-ui/core";

const styles = (theme) => ({
  dialogFooter: {
    display: "flex",
    alignItems: "flex-end",
    paddingLeft: "24px"
  },
  submitButton: {
    marginLeft: 16,
    minWidth: 140,
  },
  circularProgress: {
    color: theme.white,
  },
});

const PanelAction = (props) => {
  const {
    classes,
    handleClose,
    confirmButtonText,
    handleSubmit,
    isLoading,
    isDisabled,
    closeButtonText = "Cancel",
  } = props;
  return (
      <div className={classes.dialogFooter}>
        <Button
          autoFocus
          onClick={handleClose}
          color="primary"
          variant="outlined"
        >
          {closeButtonText}
        </Button>
        <Button
          autoFocus
          color="primary"
          variant="contained"
          onClick={!isLoading ? handleSubmit : null}
          className={classes.submitButton}
          disabled={isDisabled}
        >
          {isLoading ? (
            <CircularProgress
              size={24}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            confirmButtonText
          )}
        </Button>
    </div>
  );
};

export default withStyles(styles)(PanelAction);
